import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-client-layout',
  templateUrl: './client-layout.component.html',
  styleUrls: ['./client-layout.component.scss']
})
export class ClientLayoutComponent implements OnInit {

  constructor(
    private userService: AuthService
  ) { }

  ngOnInit(): void {
  }

  get canSeeAll(): boolean {
    return this.userService.user.can_see_all;
  }
}
